export default "__VITE_ASSET__e9726a24__"